export default __webpack_public_path__ + "static/media/8.f9f54eba.jpg";